/**
 * assertionactions.js
 * Created by benavja on 11/21/2019.
 */

import * as types from '../actiontypes';
import _ from 'lodash';
import {serviceURL} from '../../util/uiconstants';
import Env from '../../util/env';

export const getEngagementAssertions = (url, resource) => {
	return {
		type: types.GET_ASSERTIONS_FOR_ENGAGEMENTID,
		meta: {
			api: {
				url,
				method: 'GET',
				data: {resource}
			}
		}
	};
};

export const setRiskIdAssertionId = (riskId, assertionId) => {
	return {
		type: types.SET_RISKID_ASSERTIONID,
		riskId: riskId,
		assertionId: assertionId
	};
};

export const updateStoreForAssertions = (currentAssertions, assertions) => {
	let merged = [];

	if (currentAssertions && currentAssertions.length > 0) {
		// filter all non-server assertions.
		let filteredAssertions = _.filter(currentAssertions, function(assertion) {
			return assertion.riskId !== assertions[0].riskId;
		});

		merged.push(...filteredAssertions, assertions[0]);
	} else {
		merged.push(assertions[0]);
	}
	return {type: types.GET_ASSERTIONS_FOR_RISKID, response: merged};
};

export const updateAccountAssertionInherentRiskType = (engagementId, accountId, assertionId, inherentRiskTypeId) => {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}Accounts/${accountId}/Assertion/${assertionId}`;
	return {
		type: types.UPDATE_INHERENTRISKTYPE_FOR_ASSERTION,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: {
					inherentRiskTypeId: inherentRiskTypeId
				}
			}
		}
	};
};

export const updateAssertionAssociatedRisk = (engagementId, accountId, assertionId, riskDetail) => {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}Accounts/${accountId}/Assertion/${assertionId}/Risk`;
	return {
		type: types.UPDATE_RISK_FOR_ASSERTION,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: riskDetail
			}
		}
	};
};

export const deleteAccountAssertion = (engagementId, accountId, assertionId) => {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}Accounts/${accountId}/Assertion/${assertionId}`;
	return {
		type: types.DELETE_ASSERTION_FOR_ACCOUNT,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		}
	};
};

export const addAccountAssertionInherentRiskType = (
	engagementId,
	accountId,
	inherentRiskTypeId,
	statementTypeId,
	knowledgeAssertionId
) => {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}Accounts/${accountId}/Assertion`;
	return {
		type: types.ADD_INHERENTRISKTYPE_FOR_ASSERTION,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: {
					inherentRiskTypeId: inherentRiskTypeId,
					knowledgeAssertionId: knowledgeAssertionId,
					statementTypeId: statementTypeId
				}
			}
		}
	};
};
